"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDuplicateDateTimestampFilterFn = exports.getDuplicateTimestampFilterFn = void 0;
/** returns a filter to remove duplicate Date timestamps, where adjacent. and optionally where objects PASS the objectComparisonFn The second element is removed
* eg if the idx 1 and 2 timestamps match, and if objectComparison is present and passes, 2 will be removed
* CARE: this means the objectComparisonFn is a negative filter!
*/
const getDuplicateTimestampFilterFn = (objectComparisonFn) => (ob, i, arr) => {
    let pass = i === 0;
    if (i > 0) {
        const prev = arr.at(i - 1);
        const t1 = prev.timestamp instanceof Date ? prev.timestamp.valueOf() : prev.timestamp;
        const t2 = ob.timestamp instanceof Date ? ob.timestamp.valueOf() : ob.timestamp;
        pass = t1 !== t2;
        if (!pass && objectComparisonFn) {
            pass = !objectComparisonFn(ob, prev);
        }
    }
    return pass;
};
exports.getDuplicateTimestampFilterFn = getDuplicateTimestampFilterFn;
/** returns a filter to remove duplicate Date timestamps, where adjacent. and optionally where objects PASS the objectComparisonFn. The second element is removed
 * eg if the idx 1 and 2 timestamps match, and if objectComparison is present and passes, 2 will be removed
 * CARE: this means the objectComparisonFn is a negative filter!
*/
const getDuplicateDateTimestampFilterFn = (objectComparisonFn) => (ob, i, arr) => {
    let pass = i === 0;
    if (i > 0) {
        const prev = arr.at(i - 1);
        pass = prev.timestamp < ob.timestamp || prev.timestamp > ob.timestamp;
        if (!pass && objectComparisonFn) {
            pass = !objectComparisonFn(ob, prev);
        }
    }
    return pass;
};
exports.getDuplicateDateTimestampFilterFn = getDuplicateDateTimestampFilterFn;
